// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompareFooterComponent } from '@coa/app/shared/select-items-shared/components/compare-footer/compare-footer.component';
import { CompareHeaderComponent } from '@coa/app/shared/select-items-shared/components/compare-header/compare-header.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { CompareElementComponent } from './components/compare-element/compare-element.component';
import { PercentageChangeModule } from '@coa/app/shared/percentage-change/percentage-change.module';
import { CompareSelectedElementComponent } from './components/compare-selected-element/compare-selected-element.component';
import { IconTooltipModule } from '@coa/app/shared/icon-tooltip/icon-tooltip.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CompareNamePipe } from './pipes/compare-name.pipe';
import { compareFooterReducer, STATE_NAME } from '@coa/app/shared/select-items-shared/store/compare-footer.reducer';
import { CompareFooterEffects } from '@coa/app/shared/select-items-shared/store/compare-footer.effects';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FeatureToggleModule } from '@coa/app/shared/feature-toggle/feature-toggle.module';
import { CreateGroupFooterComponent } from '@coa/app/shared/select-items-shared/components/create-group-footer/create-group-footer.component';
import { AddToGroupDialogModule } from '@coa/app/shared/add-to-group-dialog/add-to-group-dialog.module';
import { CreateCompareHeaderComponent } from '@coa/app/shared/select-items-shared/components/create-compare-header/create-compare-header.component';
import { CuiButtonModule } from '@coa/app/shared/button/button.module';

@NgModule({
  declarations: [
    CompareFooterComponent,
    CompareHeaderComponent,
    CompareElementComponent,
    CompareSelectedElementComponent,
    CompareNamePipe,
    CreateGroupFooterComponent,
    CreateCompareHeaderComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule.forChild(),
    PercentageChangeModule,
    IconTooltipModule,
    StoreModule.forFeature(STATE_NAME, compareFooterReducer),
    EffectsModule.forFeature([CompareFooterEffects]),
    MatTooltipModule,
    FeatureToggleModule,
    CuiButtonModule,
    AddToGroupDialogModule,
  ],
  exports: [
    CompareFooterComponent,
    CompareHeaderComponent,
    CompareElementComponent,
    CompareSelectedElementComponent,
    CreateGroupFooterComponent,
    CreateCompareHeaderComponent,
  ],
})
export class SelectItemsSharedModule {
}
